export class AppleWalletPass {
  readonly blob: Blob;
  readonly correlationId?: string;

  constructor(blob: Blob, correlationId?: string) {
    this.blob = blob;
    this.correlationId = correlationId;
  }
}

export class GoogleWalletPass {
  readonly url: string;
  readonly correlationId?: string;

  constructor(url: string, correlationId?: string) {
    this.url = url;
    this.correlationId = correlationId;
  }
}

export interface WalletPassParams {
  appId: number;
  productType: string;
  isLegacyApp: boolean;
}
